// sidebar.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private toggleSidebarSubject = new Subject<void>();
  toggleSidebar$ = this.toggleSidebarSubject.asObservable();
  
  private previousSidebarState: 'folded' | 'unfolded' | null = null;

  toggleSidebar() {
    console.log('toggleSideBar entered in service')
    this.toggleSidebarSubject.next();
  }

  saveSidebarState(isFolded: boolean) {
    this.previousSidebarState = isFolded ? 'folded' : 'unfolded';
    console.log('Saved sidebar state:', this.previousSidebarState);
  }

  getPreviousSidebarState(): 'folded' | 'unfolded' | null {
    return this.previousSidebarState;
  }

  clearSidebarState() {
    this.previousSidebarState = null;
  }

  // Method to check if sidebar was previously unfolded
  wasSidebarUnfolded(): boolean {
    return this.previousSidebarState === 'unfolded';
  }
}
